import { i18n } from "../translate/i18n";

// Verde do "digitando..." do WhatsApp Web.
export const PRESENCE_HIGHLIGHT_COLOR = "#00A884";

const sameDay = (a, b) =>
	a.getFullYear() === b.getFullYear() &&
	a.getMonth() === b.getMonth() &&
	a.getDate() === b.getDate();

const formatTime = date =>
	date.toLocaleTimeString(i18n.language || undefined, { hour: "2-digit", minute: "2-digit" });

const formatDate = date =>
	date.toLocaleDateString(i18n.language || undefined, { day: "2-digit", month: "2-digit", year: "numeric" });

/** "hoje às 14:32" / "ontem às 09:10" / "20/10/2026 às 18:00" */
export const formatWhatsappMoment = timestamp => {
	if (!timestamp) return "";
	const date = new Date(timestamp);
	const today = new Date();
	const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
	const time = formatTime(date);

	if (sameDay(date, today)) return i18n.t("contactWhatsappStatus.todayAt", { time });
	if (sameDay(date, yesterday)) return i18n.t("contactWhatsappStatus.yesterdayAt", { time });
	return i18n.t("contactWhatsappStatus.dateAt", { date: formatDate(date), time });
};

/**
 * Texto da presença como no topo da conversa do WhatsApp.
 * `highlight` = digitando/gravando (verde, como no WhatsApp Web); "online" e
 * "visto por último" ficam no texto secundário.
 */
export const describePresence = presence => {
	if (!presence) return null;

	switch (presence.presence) {
		case "composing":
			return { text: i18n.t("contactWhatsappStatus.typing"), highlight: true };
		case "recording":
			return { text: i18n.t("contactWhatsappStatus.recording"), highlight: true };
		case "available":
			return { text: i18n.t("contactWhatsappStatus.online"), highlight: false };
		case "unavailable":
			return presence.lastSeen
				? {
						text: i18n.t("contactWhatsappStatus.lastSeen", {
							when: formatWhatsappMoment(presence.lastSeen),
						}),
						highlight: false,
				  }
				: null;
		default:
			return null;
	}
};

// Stories já vistos neste navegador (o anel fica cinza, como no WhatsApp).
const SEEN_KEY = "contactStoriesSeen";
export const STORIES_SEEN_EVENT = "contactStoriesSeen";

export const readSeenStories = () => {
	try {
		const raw = JSON.parse(localStorage.getItem(SEEN_KEY) || "{}");
		const now = Date.now();
		return Object.fromEntries(Object.entries(raw).filter(([, expiresAt]) => expiresAt > now));
	} catch (err) {
		return {};
	}
};

export const markStorySeen = story => {
	if (!story?.id) return;
	try {
		const seen = readSeenStories();
		if (seen[story.id]) return;
		seen[story.id] = story.expiresAt || Date.now() + 24 * 60 * 60 * 1000;
		localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
	} catch (err) {
		// Sem localStorage o anel só não fica cinza.
	}
	window.dispatchEvent(new Event(STORIES_SEEN_EVENT));
};
